import React from 'react';
import styles from './SubMenuButton.module.css';

const SubMenuButton = ({ label, isActive, onClick, disabled }) => {
    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        onClick();
    };

    return (
        <li
            className={`${styles.button} ${isActive ? styles.active : ''} ${disabled ? styles.disabled : ''}`}
            onClick={handleClick}
            aria-disabled={disabled}
        >
            {label}
        </li>
    );
};

export default SubMenuButton;